import { Heart, Eye, Clock } from "lucide-react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useSettings } from "../context/SettingsContext";
import MenuTags from "./MenuTags";

const MenuItemListView = ({ items, onView, selectedCatId, firstItemRef }) => {

    const DAY_LETTER_MAP = {
  "0": "Sun",
  "1": "Mon",
  "2": "Tue",
  "3": "Wed",
  "4": "Thu",
  "5": "Fri",
  "6": "Sat",
};



const getAvailabilityUI = (item) => {
  if (!item?.day) return null;

  const allDays = ["0", "1", "2", "3", "4", "5", "6"];
  const daysArray = item.day.split(",");

  const isAllDays =
    allDays.length === daysArray.length &&
    allDays.every((d) => daysArray.includes(d));

  const from = item.from_time?.slice(0, 5);
  const to = item.to_time?.slice(0, 5);

  const isFullDay = from === "00:00" && to === "23:59";

  // RULE 1: All days + full day → show nothing
  if (isAllDays && isFullDay) return null;

  // RULE 2: All days + specific hours → show time only
  if (isAllDays && !isFullDay) {
    return {
      days: null,
      time: `${from} – ${to}`,
    };
  }

  const dayLabels = daysArray
    .map((d) => DAY_LETTER_MAP[d])
    .filter(Boolean);

  return {
    days: dayLabels,
    time: isFullDay ? null : `${from} – ${to}`,
  };
};


  const user = useSelector((state) => state.auth.user);
  const [favorites, setFavorites] = useState([]);
const { settings } = useSettings();

  useEffect(() => {
    if (user?.id) {
      axios
        .get(`${window.BASE_API_URL}getuserfav/${user.id}`)
        .then((res) => setFavorites(res.data.map((f) => f.menu_id)))
        .catch(() => {});
    }
  }, [user]);

  const toggleFav = async (id) => {
    if (!user) return toast.warn("Please login to add favorites");

    const isFav = favorites.includes(id);
    const url = isFav ? "remove-favorite" : "add-favorite";

    await axios.post(`${window.BASE_API_URL}${url}`, {
      id,
      user_id: user.id,
      selectedCatId,
    });

    setFavorites((prev) =>
      isFav ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };


  
  const isItemAvailableNow = (item, timeZone = "Asia/Kolkata") => {
  if (!item?.day) return true;

  const now = new Date();

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(now);

  const dayMap = {
    Sun: "0",
    Mon: "1",
    Tue: "2",
    Wed: "3",
    Thu: "4",
    Fri: "5",
    Sat: "6",
  };

  const currentDay = dayMap[
    parts.find((p) => p.type === "weekday")?.value
  ];

  const hour = parts.find((p) => p.type === "hour")?.value;
  const minute = parts.find((p) => p.type === "minute")?.value;

  const currentTime = `${hour}:${minute}`;

  const daysArray = item.day.split(",");

  if (!daysArray.includes(currentDay)) return false;

  const from = item.from_time?.slice(0, 5);
  const to = item.to_time?.slice(0, 5);

  if (!from || !to) return true;

  return currentTime >= from && currentTime <= to;
};

const isMobile = window.innerWidth < 768;

  return (
    <div className="space-y-4 p-4">
      {items.map((item, index) => { 
        
                const availability = getAvailabilityUI(item);
const isTimeAvailable = isItemAvailableNow(
  item,
  settings?.timezone || "Asia/Kolkata"
);

const isCategoryActive =
  !item?.category || item?.category?.status === 1;

const isAvailable =
  isTimeAvailable &&
  isCategoryActive &&
  item?.status === 1;


return (
        <div
          key={item.id}
          className="flex items-center bg-white rounded-xl shadow-sm hover:shadow-md transition p-4"
           ref={index === 0 ? firstItemRef : null}
        >
          {/* Image */}
            {!isMobile && (
    <img
      src={item.image}
      alt={item.name}
      className="w-24 h-24 object-cover rounded-md"
    />
  )}


          {/* Content */}
          <div className="flex-1 ml-4">
          <h3
  className="text-lg font-bold"
  style={{ color: settings?.cart_title_color || "#111827" }} // fallback dark
>
  {item.name} 
</h3>
<MenuTags tags={item.tags} />
            <p className="text-gray-500 text-sm line-clamp-2">
              {item.description}
            </p>

{availability && (
  <div className="flex flex-wrap gap-2 mt-2">
    {/* Days */}
    {availability.days &&
      availability.days.map((day, i) => (
        <span
          key={i}
          className="px-2 py-0.5 text-xs font-semibold
                     rounded-full bg-black/70 text-white"
        >
          {day}
        </span>
      ))}

    {/* Time */}
    {availability.time && (
      <span
        className="flex items-center gap-1 px-2 py-0.5 text-xs
                   rounded-full bg-orange-500 text-white"
      >
        <Clock size={12} />
        {availability.time}
      </span>
    )}
  </div>
)}


            <div className="flex items-center justify-between mt-3">
              <span className="text-lg font-semibold">
                {localStorage.getItem("currency")} {item.price.toFixed(2)}
              </span>

              <div className="flex items-center gap-3">
                {/* Favorite */}
                {user && (
                  <button
                    onClick={() => toggleFav(item.id)}
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 z-0"
                  >
                    <Heart
                      size={18}
                      className={
                        favorites.includes(item.id)
                          ? "text-red-500 fill-red-500"
                          : "text-gray-500"
                      }
                    />
                  </button>
                )}

                {/* View Button */}
              <div className="relative group">
  <button
    disabled={!isAvailable}
    onClick={() => isAvailable && onView(item.id)}
    style={{
      background: isAvailable
        ? settings?.cart_btn_color || "#000000ff"
        : "#e5e7eb", // gray-200
      color: isAvailable
        ? settings?.cart_btn_text_color || "#ffffff"
        : "#9ca3af", // gray-400
      cursor: isAvailable ? "pointer" : "not-allowed",
    }}
    onMouseEnter={(e) => {
      if (isAvailable) {
        e.currentTarget.style.background =
          settings?.cart_btn_hover || "#f59e0b";
      }
    }}
    onMouseLeave={(e) => {
      if (isAvailable) {
        e.currentTarget.style.background =
          settings?.cart_btn_color || "#000000ff";
      }
    }}
    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm
      font-medium transition-all duration-300
      ${
        isAvailable
          ? "hover:scale-105"
          : "opacity-70"
      }`}
  >
    {isAvailable ? "View" : "Unavailable"} <Eye size={16} />
  </button>
</div>

              </div>
            </div>
          </div>
        </div>
      )})}
    </div>
  );
};

export default MenuItemListView;
